import React, { PureComponent } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import CarouselWrap from './CarouselWrap';

export default class Carousel extends PureComponent {

  static propTypes = {
    children: PropTypes.node,
    wrapAround: PropTypes.bool,
    prevNextButtons: PropTypes.bool,
  }

  static defaultProps = {
    wrapAround: true,
    prevNextButtons: false,
  }

  state = {
    opacity: 0,
    isReady: false,
    active: 0,
  }

  componentDidMount() {
    const Flickity = require('flickity');

    this.slider = new Flickity(this.flickityNode, {
      cellAlign: 'center',
      prevNextButtons: this.props.prevNextButtons,
      arrowShape: {
        x0: 10,
        x1: 50,
        y1: 25,
        x2: 50,
        y2: 15,
        x3: 25,
      },
      pageDots: false,
      wrapAround: this.props.wrapAround,
      percentPosition: true,
      imagesLoaded: true,
      ...this.props.settings,
    });

    this.setReady();

    this.slider.on('change', this.updateActive);
  }

  setReady = () => {
    this.setState({
      isReady: true,
      opacity: 1,
    });
  }

  updateActive = (active) => {
    this.setState({
      active,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const activeChange = !prevState.isReady && this.state.isReady;
    const slidesChange = prevProps.children !== this.props.children;

    if (activeChange || slidesChange) {
      this.updateFlickity();
    }
  }

  // componentWillUnmount() {
  //   this.slider.deactivate();
  //   this.slider.off('change', this.updateActive);
  //   this.slider.destroy();
  // }

  updateFlickity = () => {
    const initial = (this.props.settings && this.props.settings.initialIndex) || 0;

    this.slider.reloadCells();
    this.slider.resize();
    this.slider.updateDraggable();
    this.slider.select(initial, false, true);

    this.updateActive(initial);
  }

  renderPortal = () => {
    if (!this.flickityNode) {
      return null;
    }

    const mountNode = this.flickityNode.querySelector('.flickity-slider');
    const childWithProp = React.Children.map(this.props.children, (child, i) => (
      React.cloneElement(child, {
        index: i,
        activeSlide: this.state.active,
        length: this.props.children.length,
      })
    ));

    if (mountNode) {
      return createPortal(childWithProp, mountNode);
    }
  }

  render() {
    return [
      <CarouselWrap
        key="carousel-slider"
        ref={(node) => { this.flickityNode = node; }}
        opacity={this.state.opacity}
        styles={this.props.styles}
      />,
      this.renderPortal(),
    ].filter(Boolean);
  }
}

